import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#2A5DB4',
        },
        secondary: {
            main: '#E6B600',
        },
        background: {
            default: '#f8f8f88c',
            paper: '#FFFFFF',
        },
    },
})